// The preview eye at the right-hand end of a Tables / Variables tree row,
// shown on hover (Adam, 10 Sep call): a way to look at a table or a variable
// that is even more obviously "look, don't attach" than clicking the name.
// The name still previews too. Marked .tree-hover-action so <Tree>'s row
// reveals it only under the pointer.
import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'

export default function TreePreviewAction({ label, onPreview }: { label: string; onPreview: () => void }) {
  return (
    <Tooltip title={`Preview ${label}`} placement="left">
      <IconButton
        size="small"
        className="tree-hover-action"
        aria-label={`Preview ${label}`}
        onClick={(e) => { e.stopPropagation(); onPreview() }}
        onMouseDown={(e) => e.stopPropagation()}
        sx={{ p: '2px', color: 'text.secondary', '&:hover': { color: 'info.main' } }}
      >
        <VisibilityOutlinedIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  )
}
